import { Component, type ReactNode } from 'react'

/**
 * Contains a failure (chunk load, map or LiveKit render error) to its own
 * subtree: the homepage never goes blank because of the live hero.
 */
export class LiveHeroBoundary extends Component<{ children: ReactNode; fallback?: ReactNode; onError?: () => void }, { failed: boolean }> {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error: unknown) {
    console.error('[LiveHero]', error)
    this.props.onError?.()
  }

  render() {
    return this.state.failed ? (this.props.fallback ?? null) : this.props.children
  }
}
